import { BadgeCheck, HelpCircle } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

/**
 * A quiet ✓ Verified Gate chip.
 * Shown on the storefront header when compute_verification(seller) is true.
 * Tapping the small ? opens a short explainer that links to the Seller Policy.
 */
export default function VerifiedGateBadge({ compact = false, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="verified-gate-badge">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#B7D33F]/18 border border-[#B7D33F]/50 px-2.5 py-1 text-[#3E4A15]">
        <BadgeCheck className="w-3.5 h-3.5 text-[#94AE29]" strokeWidth={2.25} />
        <span className={`font-mono-label uppercase tracking-[0.14em] ${compact ? "text-[10px]" : "text-[11px]"}`}>
          Verified Gate
        </span>
      </span>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-label="What Verified means"
            data-testid="verified-gate-info"
            className="text-stone-500 hover:text-[#20251F] transition-colors"
          >
            <HelpCircle className="w-3.5 h-3.5" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-80" data-testid="verified-gate-popover">
          <p className="font-mono-label text-[11px] uppercase tracking-[0.14em] text-[#3F674E] mb-2">
            What Verified means
          </p>
          <p className="text-sm text-stone-800 leading-relaxed">
            Gate + Gather has confirmed this seller's contact details, pickup arrangements, payment method and their acceptance of our{" "}
            <Link to="/policy/seller-policy" className="underline text-[#3F674E] hover:text-[#20251F]" data-testid="verified-gate-policy-link">
              Seller Policy
            </Link>.
          </p>
          <p className="text-xs text-stone-500 leading-relaxed mt-3">
            Verified means checked, not curated — sellers still run their own Gates.
          </p>
        </PopoverContent>
      </Popover>
    </div>
  );
}
